import { memo } from 'react';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { InsertDriveFileOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { getFullUrl } from 'utils/index';
import { IBusinessAccountRequestDocuments } from '../../interfaces';

type BusinessAccountRequestDocumentsCellProps = {
  documents?: IBusinessAccountRequestDocuments;
};

const DOCUMENT_KEYS: Array<keyof IBusinessAccountRequestDocuments> = ['legalRegistration', 'taxIdDocument'];

const BusinessAccountRequestDocumentsCell = ({ documents }: BusinessAccountRequestDocumentsCellProps) => {
  const { t } = useTranslation('businessAccountRequest');

  return (
    <Stack direction='row' spacing={0.5}>
      {DOCUMENT_KEYS.map((key) => {
        const doc = documents?.[key];
        if (!doc?.url) return null;
        return (
          <Tooltip key={key} title={doc.originalname || t(`fields.documents.${key}`)}>
            <IconButton size='small' component='a' href={getFullUrl(doc.url)} target='_blank' rel='noopener noreferrer'>
              <InsertDriveFileOutlined fontSize='small' />
            </IconButton>
          </Tooltip>
        );
      })}
    </Stack>
  );
};

export default memo(BusinessAccountRequestDocumentsCell);
